/**
 * Format a number as a USD-style decimal string with always-two decimal places.
 *
 *   formatMoney(0)         // "0.00"
 *   formatMoney(99.9)      // "99.90"
 *   formatMoney(100)       // "100.00"
 *   formatMoney(99.999)    // "100.00"   (rounds half-to-even per toFixed)
 *
 * No currency symbol — callers prepend "$" inline. Keeping it symbol-free lets
 * the same helper work for any currency-unit display.
 */
export function formatMoney(value: number): string {
  return value.toFixed(2);
}
